import React from "react";
import { Box } from "@mui/material";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import { Theme } from "../../providers/ThemeProvider";
import useTheme from "../hooks/useTheme";

type Props = {
  /** Diameter of the circular button in px. Defaults to 82. */
  size?: number;
};

/**
 * Branded play button — a white circle with a primary-blue play triangle.
 * Used as the click-to-play overlay on `VideoPlayer`.
 */
const VideoPlayButton = ({ size = 82 }: Props) => {
  const theme: Theme = useTheme();

  return (
    <Box sx={styles.button(theme, size)}>
      <PlayArrowRoundedIcon sx={styles.icon(theme, size)} />
    </Box>
  );
};

export default VideoPlayButton;

const styles = {
  button: (theme: Theme, size: number) => ({
    width: `${size}px`,
    height: `${size}px`,
    borderRadius: "50%",
    backgroundColor: theme.colors_ds.NEUTRAL_GENERAL_WHITE,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0px 8px 24px rgba(0,0,0,0.35)",
    cursor: "pointer",
    transition: "transform 0.15s ease",
    "&:hover": {
      transform: "scale(1.08)",
    },
  }),
  icon: (theme: Theme, size: number) => ({
    color: theme.colorTokens.P[80],
    fontSize: `${size * 0.55}px`,
    // Optical centering — the triangle's visual mass sits slightly left.
    marginLeft: `${size * 0.04}px`,
  }),
};
